import React from 'react';

export const UserAnimationIcon = ({ size = 22, color }) => (
  <svg id="default-avatar" xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 22 22" fill="none">
  <path className="head-user" fillRule="evenodd" clipRule="evenodd"
    d="M10.9997 2.19308C9.03688 2.19308 7.44569 3.78428 7.44569 5.74712C7.44569 7.70996 9.03688 9.30115 10.9997 9.30115C12.9626 9.30115 14.5538 7.70996 14.5538 5.74712C14.5538 3.78428 12.9626 2.19308 10.9997 2.19308ZM6.07069 5.74712C6.07069 3.02489 8.27749 0.818085 10.9997 0.818085C13.7219 0.818085 15.9288 3.02489 15.9288 5.74712C15.9288 8.46935 13.7219 10.6761 10.9997 10.6761C8.27749 10.6761 6.07069 8.46935 6.07069 5.74712Z"
    fill={color}/>
  <path className="body-user" fillRule="evenodd" clipRule="evenodd"
    d="M10.3817 12.9166C6.91266 12.9166 4.10046 15.7288 4.10046 19.1978C4.10046 19.2992 4.18266 19.3814 4.28405 19.3814H17.7161C17.8175 19.3814 17.8997 19.2992 17.8997 19.1978C17.8997 15.7288 15.0875 12.9166 11.6185 12.9166H10.3817ZM2.72546 19.1978C2.72546 14.9694 6.15327 11.5416 10.3817 11.5416H11.6185C15.8469 11.5416 19.2747 14.9694 19.2747 19.1978C19.2747 20.0586 18.5769 20.7564 17.7161 20.7564H4.28405C3.42327 20.7564 2.72546 20.0586 2.72546 19.1978Z"
    fill={color}/>
</svg>
);


// WEBPACK FOOTER //
// ./src/assets/icons/UserAnimation.icon.jsx